import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { getTranslate } from 'react-localize-redux';

import { handleSideBar } from '../Generic/actions/genericActions';
import withMediaQuery from '../withMediaQuery';

import { AppBar, Box, Container, Toolbar, Slide, useScrollTrigger, Alert } from '@mui/material';

import CatalogueGrid from './CatalogueGrid';
import { catalogue_structure } from '../../catalogues';

// Hide AppBar on scroll
function HideOnScroll({ children, window }) {
	const trigger = useScrollTrigger({
		target: window ? window() : undefined,
	});
	return (
		<Slide appear={false} direction="down" in={!trigger}>
			{children}
		</Slide>
	);
}

HideOnScroll.propTypes = {
	children: PropTypes.element.isRequired,
	window: PropTypes.func,
};

export const NavBar = ({ catalogue, push, handleSideBar, ...props }) => {
	const { client, persistent_alert, side_bar } = props;

	if (!client) return null;

	return (
		<React.Fragment>
			<HideOnScroll {...props}>
				<AppBar
					className="generic-navbar-main"
					sx={{
            backgroundColor: '#fff',
					  borderBottom: '1px solid #e0e0e0',
					  boxShadow: '0 -2px 6px rgba(0,0,0,0.08)',
            ...(side_bar?.drawer_props?.variant === 'permanent' && {
							zIndex: (theme) => theme.zIndex.drawer + 1,
						}),
					}}
				>
					<Toolbar disableGutters sx={{ p: 1, display: 'flex' }}>
						<CatalogueGrid catalogue={catalogue} />
					</Toolbar>

					{persistent_alert?.open && (
						<Alert severity={persistent_alert.severity} action={persistent_alert.action} icon={persistent_alert.icon}>
							{persistent_alert.message}
						</Alert>
					)}
				</AppBar>
			</HideOnScroll>

			{/* Placeholder to preserve layout height */}
			<Toolbar />

			{/* Hidden alert to offset space if alert is active */}
			{persistent_alert?.open && <Alert sx={{ visibility: 'hidden' }} />}
		</React.Fragment>
	);
};

NavBar.propTypes = {
	catalogue: PropTypes.shape(catalogue_structure),
	config: PropTypes.object.isRequired,
	client: PropTypes.object,
	whoami: PropTypes.object,
	persistent_alert: PropTypes.object,
	side_bar: PropTypes.object,
};

const mapStateToProps = (state) => ({
	config: state.config,
	settings: state.settings,
	client: state.login.client ?? null,
	whoami: state.users.whoami,
	translate: getTranslate(state.localize),
	persistent_alert: state.generic.persistent_alert,
	layouts: state.generic.layouts,
	side_bar: state.generic.side_bar,
});

const mapDispatchToProps = {
	push,
	handleSideBar,
};

export default connect(mapStateToProps, mapDispatchToProps)(withMediaQuery()(NavBar));
